var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 140,
    viewBox: "0 0 181 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 139.5L91 55L49.5 0L181 139.5H154Z",
    fill: "#3336DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1984 81L51.5 140H32L76.9397 66.5888L85.1984 81Z",
    fill: "#3336DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 57.5L19.5 140H0L62.5 42.5L71.5 57.5Z",
    fill: "#3336DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 139.5L83.654 81L38.5 2.5L142.5 139.5H115.5Z",
    fill: "#3336DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5cf65581f1e99eb6556dcd990f128bad.svg";
export { ForwardRef as ReactComponent };